import SvgIcon, {Icon} from "@components/svg-icon";
import Dropdown from "@components/dropdown";
import React from "react";
import {useTicketDropdownMenu} from "@pages/tickets/hooks/useTicketDropdownMenu";
import {useTicketDropdownLabels} from "@pages/tickets/hooks/useTicketDropdownLabels";
import {TicketFilterOptions} from "@pages/tickets/models/ticket-list-type";
import "./ticket-dropdown.scss"

export  const TicketDropdown = () => {
    const {dropdownModel, dropdownVisibility, elementRef, selectedOption, setDropdownVisibility} = useTicketDropdownMenu();
    const {getLabel} = useTicketDropdownLabels();

    return <div ref={elementRef} className='relative pr-10 '>
        <div className='relative flex flex-row items-center text-m cursor-pointer flex-nowrap'
             onClick={() => setDropdownVisibility(!dropdownVisibility)}>
            <div className='min-w-44'>{getLabel(selectedOption) ?? getLabel(TicketFilterOptions.ShowAllTicket)}</div>
            <span className='px-5'>
                    <SvgIcon type={dropdownVisibility ? Icon.ArrowUp : Icon.ArrowDown} className='cursor-pointer'
                             fillClass='active-item-icon'/>
                </span>

        </div>
        <div>

            {dropdownVisibility &&
                <div className="absolute flex-nowrap z-10 mt-6 top-full">
                    <Dropdown model={dropdownModel}/>
                </div>
            }
        </div>
    </div>
}